// A <Navigate> for moved routes that keeps bookmarks working: `:param`
// segments in `to` are filled from the old URL, and the old query string and
// hash are carried over (keys the target sets explicitly win).

import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { buildRedirectTarget } from "./redirectTarget";

const PreservingRedirect = ({ to }) => {
  const params = useParams();
  const location = useLocation();
  return (
    <Navigate
      replace
      to={buildRedirectTarget(to, params, location.search, location.hash)}
      state={location.state}
    />
  );
};

export default PreservingRedirect;
